import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

function useBehaviorSelectionTreeChecked(fromTree = true) {
    const [selectedKeyword, setselectedKeyword] = useState([]);
    const [checkedKeys, setcheckedKeys] = useState([]);

    const {
        configuration: {
            toEditData
        }
    } = useSelector((state) => state.marketExplorer);

    useEffect(() => {
        if (toEditData.data && toEditData.mode === "edit") {
            if (!fromTree && toEditData.data.code !== "target_focus") return;
            const toEditTargets = [...toEditData.data.targets]
            setselectedKeyword(toEditTargets);
            const tempList = [];
            const checkAllRecursive = (items) => {
                items.forEach((child) => {
                    tempList.push(child);
                    const childList = (child.children || child.tempChildren);
                    if (childList && childList.length) {
                        checkAllRecursive(childList);
                    }
                });
            };
            checkAllRecursive(toEditTargets);
            setcheckedKeys(tempList);
        }
    }, [fromTree, toEditData]);

    return {
        selectedKeyword,
        checkedKeys,
        setselectedKeyword,
        setcheckedKeys
    };
}

export default useBehaviorSelectionTreeChecked;
